:host {
  --spinner-font-size: 16px;
  --spinner-font-color: #ffffff;

  font-size: var(--spinner-font-size);
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: max-content;
}

:host(.is-vertical) {
  font-size: var(--spinner-font-size);
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

:host .jackery-loading-spinner {
  display: block;
  fill: currentcolor;
  overflow: hidden;
  width: calc(var(--spinner-font-size) + 2px);
  height: calc(var(--spinner-font-size) + 2px);
  margin: auto;
  color: var(--spinner-font-color);
}

:host .jackery-loading-text {
  text-indent: 6px;
  color: var(--spinner-font-color);
  font-size: var(--spinner-font-size);
}

:host(.is-vertical) .jackery-loading-text {
  margin-left: 0;
  margin-top: 6px;
  text-indent: 0;
}

:host slot:empty .quark-loading-text {
  font-size: 0;
  margin: 0;
}